import { isPlatformBrowser } from "@angular/common";
import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, Router } from "@angular/router";
import { of } from "rxjs";
import { ApiService } from "src/app/services/api.service";
import { GlobalDataService } from "src/app/services/global-data.service";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class MovieDetailDataService implements Resolve<any> {
  movieSlug: string;
  movieDetail;
  nowShowing;
  comingSoon;
  sessions;
  cinemaProvider;
  waitedForFetch: boolean = false;

  constructor(
    private API: ApiService,
    private router: Router,
    private globalData: GlobalDataService,
    @Inject(PLATFORM_ID) private platformId
  ) { }

  filterData(moviesData, route) {
    this.nowShowing = moviesData.nowShowing;
    this.comingSoon = moviesData.comingSoon;
    this.sessions = moviesData.movies.sessions;
    this.cinemaProvider = moviesData.cinemaProvider;

    this.movieSlug = route.paramMap.get("slug");

    if (this.nowShowing.filter((movie) => movie.id.toLowerCase() === this.movieSlug || movie.id === this.movieSlug)[0]) {
      this.movieDetail = this.nowShowing.filter(
        (movie) => movie.id.toLowerCase() === this.movieSlug || movie.id === this.movieSlug
      )[0];
    } else {
      this.movieDetail = this.comingSoon.filter(
        (movie) => movie.id.toLowerCase() === this.movieSlug || movie.id === this.movieSlug
      )[0];
      if (this.movieDetail) this.movieDetail.comingSoon = true;
    }

    if (this.movieDetail) {
      return {
        movieDetail: this.movieDetail,
        nowShowing: this.nowShowing,
        comingSoon: this.comingSoon,
        sessions: this.sessions,
        cinemaProvider: this.cinemaProvider,
      };
    } else {
      this.router.navigate(["/movies"]);
      return of(null);
    }
  }

  resolve(route: ActivatedRouteSnapshot) {
    const initialMallData = this.globalData.getGlobalData();

    if (initialMallData?.nowShowing) {
      return this.filterData(initialMallData, route);
    } else if (isPlatformBrowser(this.platformId)) {
      return new Promise((resolve, reject) => {
        this.API.GET(
          environment.cdn_url +
          "movies/" +
          (initialMallData?.cinemaProvider?.name === "Nu Metro"
            ? "moviesNuMetro.json"
            : "moviesSK.json")
        ).subscribe({
          next: (movies) => {
            if (movies.data.sessions) {
              this.globalData.setMovieData(movies.data);
              resolve(this.filterData(this.globalData.getGlobalData(), route));
            } else {
              this.router.navigate(["/movies"]);
              reject(null);
            }
          },
          error: (error) => {
            this.router.navigate(["/movies"]);
            reject(null);
          },
        });
      });
    }
  }
}
